import { Button, Col, Form, Input, Row, Typography } from 'antd'
import React from 'react'
import MobileNumber from '../../../../utils/components/MobileNumber/MobileNumber'
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'
import MessageModal from '../../../../utils/components/MessageModal/MessageModal'
import ConstantMessages from '../../../../utils/Strings'
import { connect } from 'react-redux'
import { updateUserProfileRequest } from '../../UserApiActions'

const CompleteProfileForm = (props) => {
    const [form] = Form.useForm();

    const fieldValidationRules = {
        username: {
            rules: [
                { type: 'email', message: ConstantMessages.enterValidEmailAddress },
                { required: true, message: ConstantMessages.emailAddressRequired }
            ],
        },
        firstName: {
            rules: [
                { required: true, message: ConstantMessages.firstNameRequired },
                { max: 50, message: 'Maximum 50 characters allowed' }
            ]
        },
        lastName: {
            rules: [
                { required: true, message: ConstantMessages.lastNameRequired },
                { max: 50, message: 'Maximum 50 characters allowed' }
            ]
        },
        location: {
            rules: [
                { required: true, whitespace: true, message: ConstantMessages.locationRequired },
                { max: 255, message: 'Maximum 255 characters allowed' }
            ]
        }
    };
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%', maxWidth: '800px' }}>
                <Row>
                    <Col span={24}>
                        <Form
                            className="flex-vertical-gap-4"
                            form={form}
                            layout="vertical"
                            style={{
                                width: '100%',
                                padding: 0,
                                backgroundColor: 'transparent'
                            }}
                            onFinish={props.handleSubmit}
                            initialValues={{
                                username: props.loggedInUser.username,
                                firstName: props.loggedInUser.firstName,
                                lastName: props.loggedInUser.lastName,
                                location: props.loggedInUser.location,
                                phone: props.loggedInUser.phone,
                                organization: props.loggedInUser.organization !== null ? props.loggedInUser.organization.name : '',
                            }}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <Form.Item name="firstName" label={<>First Name &nbsp;<span className='required'>*</span></>} {...fieldValidationRules.firstName}>
                                        <Input placeholder="Enter first name" maxLength={50} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <Form.Item name="lastName" label={<>Last Name &nbsp;<span className='required'>*</span></>} {...fieldValidationRules.lastName}>
                                        <Input placeholder="Enter last name" maxLength={50} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <Form.Item name='username' label={<>Email address &nbsp;<span className='required'>*</span></>} {...fieldValidationRules.username}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <MobileNumber name="phone" label={<>Mobile Number &nbsp;<span className='required'>*</span></>} required />
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <Form.Item name="location" label={<>Location &nbsp;<span className='required'>*</span></>} {...fieldValidationRules.location}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <Form.Item name="organization" label={<>Organization Name &nbsp;<span className='required'>*</span></>} {...fieldValidationRules.organization}>
                                        <Input placeholder="" disabled={props.currentRole.isAnalyst} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <div className="flex-vertical-gap-4 margin-top-2" style={{ alignItems: 'center' }}>
                                        <Button block type="primary" htmlType="submit">
                                            Save Changes
                                            <CustomIcon name="Check" />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>

            </div>
        </div>
    )
}
const mapStateToProps = (state) => ({
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole,
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateUserProfile: (id, data) => {
            return dispatch(updateUserProfileRequest(id, data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompleteProfileForm);